import { Injectable } from '@angular/core';
import { type Observable, of } from 'rxjs';

/** The history a running app has: none, so nothing is ever restoring. */
class NoLayoutHistory implements LayoutHistory {
  readonly isRestoring$: Observable<boolean> = of(false);
}

/**
 * Tells the engine whether an undo or redo is currently rewriting the layout.
 *
 * Layout syncing has to stand still while one is: the layout is mid-restore, and saving it would
 * persist a half-applied snapshot. The history itself is editor state and lives in
 * `dashboard/editor/data-access`, which binds this hook; nothing here knows how history works.
 *
 * why a hook at all: `LayoutSyncService` is the one engine service that needs the flag, and it is an
 * editor-time service still sitting in `runtime/engine/feature`. Once the god-service split moves it
 * to `scope:dashboard` it can read the history selectors directly and this hook retires.
 */
@Injectable({ providedIn: 'root', useFactory: () => new NoLayoutHistory() })
export abstract class LayoutHistory {
  /** Emits `true` from the moment an undo/redo is requested until the layout is restored. */
  abstract readonly isRestoring$: Observable<boolean>;
}
